import { configApiRef, useApi } from '@backstage/frontend-plugin-api';
import { docsPortalUrl } from '@internal/plugin-stack-common';

/** The policy and quota guide on this environment's docs portal. */
export function usePolicyGuideUrl(anchor?: string): string | undefined {
  const appBaseUrl = useApi(configApiRef).getOptionalString('app.baseUrl');
  return docsPortalUrl(
    appBaseUrl,
    `/platform/policies/${anchor ? `#${anchor}` : ''}`,
  );
}
